/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import Swal from 'sweetalert2';
import MDButton from 'components/MDButton';
import { api } from '../../../api';
import { getCurrentUserId } from '../constants';

const REASON_MIN_LENGTH = 5;

export default function CancelDialog({ appointment, onClose, onDone }) {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (reason.trim().length < REASON_MIN_LENGTH) {
      Swal.fire({ icon: 'warning', title: 'Reason required', text: `Please enter at least ${REASON_MIN_LENGTH} characters.` });
      return;
    }
    const confirmResult = await Swal.fire({
      title: 'Cancel this appointment?',
      text: 'This cannot be undone from here — a new appointment would need to be scheduled.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d32f2f',
      confirmButtonText: 'Yes, Cancel It',
      cancelButtonText: 'Keep It',
    });
    if (!confirmResult.isConfirmed) return;

    setSubmitting(true);
    try {
      await api.appointment.cancel(appointment.id, { reason: reason.trim(), updated_by: getCurrentUserId() });
      Swal.fire({ icon: 'success', title: 'Appointment cancelled', timer: 1800, showConfirmButton: false });
      onDone?.();
    } catch {
      // generic error toast already shown by ApiClient
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Cancel Appointment</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          <Typography variant="body2" color="textSecondary">
            Please provide a reason for cancelling this appointment.
          </Typography>
          <TextField
            label="Cancellation reason"
            size="small"
            fullWidth
            multiline
            minRows={3}
            value={reason}
            onChange={e => setReason(e.target.value)}
            autoFocus
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <MDButton onClick={onClose} color="secondary">Back</MDButton>
        <MDButton onClick={handleSubmit} disabled={submitting} variant="gradient" color="error">
          {submitting ? 'Cancelling…' : 'Cancel Appointment'}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
